import { render, staticRenderFns } from "./SimpleDonutChart.vue?vue&type=template&id=a4bd191e&scoped=true"
import script from "./SimpleDonutChart.vue?vue&type=script&lang=js"
export * from "./SimpleDonutChart.vue?vue&type=script&lang=js"
import style0 from "./SimpleDonutChart.vue?vue&type=style&index=0&id=a4bd191e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bd191e",
  null
  
)

export default component.exports